import { apiClient } from '../../utils';
import { handleError } from '../';

export const getBlogPost = async ({ id, siteId }) => {
  try {
    const { result } = await apiClient.post('/merchant/blog/get', {
      data: { id, site: siteId },
    });
    return result;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
